module.exports = __webpack_public_path__ + "static/media/opticas-cristal.3e487956.png";